import Config from "@skin_config";

const methodNames = 'WyJhcHBSZWFkeSIsImxvY2tUZXJtaW5hbCIsImJ1bGtUaXRvT3BlcmF0aW9uIiwicHJpbnRUaWNrZXQiXQ==';

const isDev = _MODE_ === 'development';

export const hasIgorSignature = () => {
  const methodNamesArray = JSON.parse(atob(methodNames));
  const methodsObject = window.jsobject || window.external;
  return typeof methodsObject === 'object' && methodNamesArray.every(item => item in methodsObject);
};

const getHashForWebsitePass = async pass => {
  const byteArray = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(pass));
  const hashArray = Array.from(new Uint8Array(byteArray));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
};

export const checkForWebsitePass = async () => {
  if (isDev || hasIgorSignature() || !Config.main.websitePasswordHash) return true;

  if (!crypto.subtle) throw "Can't check for pass";

  const pass = window.sessionStorage.getItem('websitePass') || prompt('Password');
  const hash = await getHashForWebsitePass(pass);
  const isCorrect = hash === Config.main.websitePasswordHash;

  if (isCorrect) {
    window.sessionStorage.setItem('websitePass', pass);
    return true;
  }

  window.sessionStorage.removeItem('websitePass');
  return checkForWebsitePass();
};
